// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"000c230f0f2b5b9a3b35","655":"4618c736f1c89ea95ea6"}[chunkId] + ".js";
};